// custom code for casmere
document.addEventListener('DOMContentLoaded', function() {
  const isHome = document.querySelector('body').classList.contains('template-index');
  if (!isHome) return;
  const triggerElement = document.querySelector('[data-id="triggerMenuChange"]');
  const navElement = document.getElementById('nav');
  const triggerPoint = triggerElement.offsetTop; 
  const belowFoldClass = 'compact';

  window.addEventListener('scroll', function() {
    if (window.scrollY > triggerPoint) {
      // add blur class to nav
      navElement.classList.add(belowFoldClass);
    } else {
      // remove blur class from nav
      navElement.classList.remove(belowFoldClass);
    }
  });
});